import React from "react";
import PropTypes from "prop-types";

// Import all front side images
import front_side_1 from "../../../images/front_side/1.jpg";
import front_side_2 from "../../../images/front_side/2.jpg";
import front_side_3 from "../../../images/front_side/3.jpg";
import front_side_4 from "../../../images/front_side/4.jpg";
import front_side_5 from "../../../images/front_side/5.jpg";
import front_side_6 from "../../../images/front_side/6.jpg";
import front_side_7 from "../../../images/front_side/7.jpg";
import front_side_8 from "../../../images/front_side/8.jpg";
import front_side_9 from "../../../images/front_side/9.jpg";
import front_side_10 from "../../../images/front_side/10.jpg";
import front_side_11 from "../../../images/front_side/11.jpg";

// Import back side images for mouse enter functionality
import back_side_1 from "../../../images/back_side/1.jpg";

const FrontBodyPart = ({
  frontBodyPartValue = front_side_1,
  onClickBodyParts,
  handleMouseEnter,
  handleMouseLeave,
}) => {
  return (
    <div  className="body_view_figure">
      <img src={frontBodyPartValue} alt="Body" style={{ width: "100%" }} />

      {/* Head and Neck Front */}
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Head and Neck Front")}
        style={{
          top: "3%",
          left: "39%",
          width: "21%",
          height: "14%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_2, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Head and Neck Front")}
        style={{
          top: "17%",
          left: "32%",
          width: "36%",
          height: "3%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_2, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />

      {/* Shoulder and Arm Front */}
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Shoulder and Arm Front")}
        style={{
          top: "18%",
          left: "19%",
          width: "13%",
          height: "16%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_3, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Shoulder and Arm Front")}
        style={{
          top: "18%",
          right: "19%",
          width: "13%",
          height: "16%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_3, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />

      {/* Elbow Front */}
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Elbow Front")}
        style={{
          top: "34%",
          left: "17%",
          width: "11%",
          height: "3.2%",
          transform: "rotate(6deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_4, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Elbow Front")}
        style={{
          top: "34%",
          right: "19%",
          width: "11%",
          height: "3.2%",
          transform: "rotate(-6deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_4, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />

      {/* Forearm wrist and hand front */}
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Forearm wrist and hand front")}
        style={{
          top: "37%",
          left: "15%",
          width: "12%",
          height: "11%",
          transform: "rotate(6deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_5, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Forearm wrist and hand front")}
        style={{
          top: "47.5%",
          left: "8.5%",
          width: "14.5%",
          height: "10.5%",
          transform: "rotate(6deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_5, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Forearm wrist and hand front")}
        style={{
          top: "47.5%",
          right: "6.5%",
          width: "14.5%",
          height: "10.5%",
          transform: "rotate(-6deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_5, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Forearm wrist and hand front")}
        style={{
          top: "37%",
          right: "15%",
          width: "12%",
          height: "11%",
          transform: "rotate(-8deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_5, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />

      {/* Chest */}
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Chest")}
        style={{
          top: "20%",
          left: "32%",
          width: "35%",
          height: "9%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_6, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />

      {/* Abdomen */}
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Abdomen")}
        style={{
          top: "29%",
          left: "32%",
          width: "35%",
          height: "13%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_7, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />

      {/* Pelvis Front */}
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Pelvis Front")}
        style={{
          top: "42%",
          left: "32%",
          width: "36%",
          height: "10%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_8, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />

      {/* Upper Leg Front */}
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Upper Leg Front")}
        style={{
          top: "52%",
          left: "30%",
          width: "19%",
          height: "10%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_9, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Upper Leg Front")}
        style={{
          top: "52%",
          right: "31%",
          width: "19%",
          height: "10%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_9, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Upper Leg Front")}
        style={{
          top: "62%",
          left: "32%",
          width: "17%",
          height: "6.5%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_9, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Upper Leg Front")}
        style={{
          top: "62%",
          right: "33%",
          width: "17%",
          height: "6.5%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_9, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />

      {/* Knees Front */}
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Knees Front")}
        style={{
          top: "68.5%",
          left: "35%",
          width: "13%",
          height: "6.5%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_10, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Knees Front")}
        style={{
          top: "68.5%",
          right: "36%",
          width: "13%",
          height: "6.5%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_10, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />

      {/* Lower Legs and Feet front */}
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Lower Legs and Feet front")}
        style={{
          top: "75%",
          left: "35%",
          width: "13%",
          height: "12%",
          transform: "rotate(-3deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_11, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Lower Legs and Feet front")}
        style={{
          top: "75%",
          right: "36%",
          width: "13%",
          height: "12%",
          transform: "rotate(3deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_11, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Lower Legs and Feet front")}
        style={{
          top: "86.8%",
          left: "39%",
          width: "8%",
          height: "7%",
          transform: "rotate(-3deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_11, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Lower Legs and Feet front")}
        style={{
          top: "86.8%",
          right: "40%",
          width: "8%",
          height: "7%",
          transform: "rotate(3deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_11, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Lower Legs and Feet front")}
        style={{
          top: "93.6%",
          left: "36%",
          width: "11%",
          height: "4%",
          transform: "rotate(-3deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_11, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Lower Legs and Feet front")}
        style={{
          top: "93.6%",
          right: "37%",
          width: "11%",
          height: "4%",
          transform: "rotate(3deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_11, back_side_1)}
        onMouseLeave={handleMouseLeave}
      />
    </div>
  );
};

FrontBodyPart.propTypes = {
  frontBodyPartValue: PropTypes.string,
  onClickBodyParts: PropTypes.func.isRequired,
  handleMouseEnter: PropTypes.func.isRequired,
  handleMouseLeave: PropTypes.func.isRequired,
};

export default FrontBodyPart;
